export default function TuAmigo() {
  return (
    <div className="bg-gradient-to-t from-slate-100 to-royalBlue">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 p-4 max-w-screen-xl mx-auto">
        {/* Horizontal Text Box - Move this BELOW the first horizontal image to appear on second row */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 row-span-1 aspect-video bg-white rounded-2xl shadow-md p-6 flex items-center justify-center text-center lg:grid-cols-2">
          <div>
            <h1 className="text-royalBlue text-xl pt-2 font-semibold">
              🎥 Tu Amigo: A Powerful Drama on Friendship and Obsession
            </h1>
            <p className="text-m text-gray-800">
              Tu Amigo tells the gripping story of Alejandro, whose childhood
              abuse shapes his troubled friendships and leads to a dangerous
              obsession with his new friend Roberto. Directed and written by
              Maria Alejandra and Christopher Hernandez, and performed by NYC
              Latin Media’s talented students, this project shines a light on
              complex emotions and the consequences of unresolved pain.
            </p>
          </div>
        </div>
        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-2 bg-gray-100 rounded-2xl overflow-hidden shadow-md">
          <img
            src="../Imgs/TuAmigo/Tu Amigop Poster.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        {/* Vertical Image */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2 row-span-2 bg-gray-100 rounded-2xl overflow-hidden shadow-md">
          <img
            src="../Imgs/TuAmigo/TU AMIGO TIME SQUARE.jpg"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}
